/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdrop-bak.vue?vue&type=template&id=3c7d35bd&scoped=true"
import script from "./airdrop-bak.vue?vue&type=script&lang=js"
export * from "./airdrop-bak.vue?vue&type=script&lang=js"
import style0 from "./airdrop-bak.vue?vue&type=style&index=0&id=3c7d35bd&prod&lang=scss"
import style1 from "./airdrop-bak.vue?vue&type=style&index=1&id=3c7d35bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d35bd",
  null
  
)

export default component.exports